// import { media, pxToRem } from "src/styles/styleUtils";
import usePicksContext, { setFocusedColumn } from "@hooks/usePicksContext";
import { hexRGBA, media, pxToRem } from "src/styles/styleUtils";
import styled from "styled-components";
import { ButtonBase } from "./Button";
import RightArrowSVG from "./svgs/right-arrow.svg";

function MobileRoundSelector() {
  const [{ focusedColumn }, dispatch] = usePicksContext();

  return (
    <Wrapper>
      <ControlArea>
        <button
          disabled={focusedColumn === 0}
          onClick={() => dispatch(setFocusedColumn(focusedColumn - 1))}
          aria-label={`Navigate to previous round`}
        >
          <RightArrowSVG width="15" height="15" />
        </button>

        <ColumnBars focusedColumn={focusedColumn}>
          <button tabIndex={-1} onClick={() => dispatch(setFocusedColumn(0))} />
          <button tabIndex={-1} onClick={() => dispatch(setFocusedColumn(1))} />
          <button tabIndex={-1} onClick={() => dispatch(setFocusedColumn(2))} />
          <button tabIndex={-1} onClick={() => dispatch(setFocusedColumn(3))} />
          <button tabIndex={-1} onClick={() => dispatch(setFocusedColumn(4))} />
        </ColumnBars>
        <button
          disabled={focusedColumn === 4}
          onClick={() => dispatch(setFocusedColumn(focusedColumn + 1))}
          aria-label={`Navigate to next round`}
        >
          <RightArrowSVG width="15" height="15" />
        </button>
      </ControlArea>
    </Wrapper>
  );
}

export default MobileRoundSelector;

const Wrapper = styled.div`
  display: none;
  ${media.tablet} {
    display: flex;
    justify-content: center;
  }
`;
const ControlArea = styled.div`
  flex: 0 1 ${pxToRem(280)};
  min-height: ${pxToRem(42)};
  position: relative;
  top: ${pxToRem(-4)};
  background: linear-gradient(-180deg, #f7f7f7 0%, #ffffff 100%);
  box-shadow: 0px 0px ${pxToRem(12)} 0 ${hexRGBA("#000", 0.16)};
  border: 1px solid ${({ theme }) => theme.grey_700};

  display: flex;
  justify-content: space-between;
  align-items: center;

  > button {
    ${ButtonBase}
    min-height: 100%;
    padding: 0 ${pxToRem(12)};

    &:first-of-type svg {
      transform: rotate(180deg);
    }
  }
`;

const ColumnBars = styled.div<{ focusedColumn: number }>`
  flex: 1 1 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    ${ButtonBase}
    padding: 0;
    flex: 0 0 ${pxToRem(10)};
    min-height: ${pxToRem(10)};
    background-color: ${({ theme }) => theme.grey_100};
    transition: background 0.2s ease-in-out;

    &:not(:last-child) {
      margin-right: ${pxToRem(5)};
    }

    &:nth-of-type(${({ focusedColumn }) => focusedColumn + 1}) {
      background-color: ${({ theme }) => theme.gold};
    }
    &:nth-of-type(1) {
      min-height: ${pxToRem(31)};
    }
    &:nth-of-type(2) {
      min-height: ${pxToRem(26)};
    }
    &:nth-of-type(3) {
      min-height: ${pxToRem(19)};
    }
    &:nth-of-type(4) {
      min-height: ${pxToRem(15)};
    }
  }
`;
